<template>
  <FormItem :name="name">
    <input type="date" v-model="model" :readonly="readonly" :disabled="disabled" />
  </FormItem>
  <!--p class='debug'>model value = {{ model }}</p>-->
</template>

<script setup lang="ts">
import FormItem from './Form-item.vue'
const props = defineProps({
  name: { type: String, required: true },
  //placeholder: { type: String },
  disabled: { type: Boolean },
  readonly: { type: Boolean }
})

const model = defineModel<any>({ required: true })
</script>
